import {
  Select as ChakaUIReactSelect,
  AsyncSelect as ChakraUIReactAsyncSelect,
  ChakraStylesConfig
} from "chakra-react-select";
import { useColorModeValue } from "@chakra-ui/react";
import { chakraComponents, DropdownIndicatorProps } from "chakra-react-select";
import { Box } from "@chakra-ui/react";

const generateChakraStyles = (styles: {
  fontSize: string;
  isFullWidth: boolean;
  size: "sm" | "md" | "lg";
  placeholderColor: string;
}) => {
  const { size, fontSize, isFullWidth, placeholderColor } = styles;

  const chakraStyles: ChakraStylesConfig = {
    placeholder: (provided) => ({
      ...provided,
      color: placeholderColor,
      fontSize: "0.875rem",
      lineHeight: "133%",
      fontWeight: "normal",
      maxWidth: "calc(100% - 15px)",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }),
    control: (provided) => ({
      ...provided,
      fontSize: fontSize
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 1000
    }),
    container: (provided) => ({
      ...provided,
      minWidth: isFullWidth ? "auto" : 185
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      width: size === "sm" ? 4 : size === "md" ? 5 : 6,
      height: size === "sm" ? 4 : size === "md" ? 5 : 6
    }),
    clearIndicator: (provided) => ({
      ...provided,
      width: size === "sm" ? 4 : size === "md" ? 5 : 6,
      height: size === "sm" ? 4 : size === "md" ? 5 : 6,
      marginInlineStart: size === "sm" ? 3 : size === "md" ? 3 : 5,
      marginInlineEnd: size === "sm" ? 3 : size === "md" ? 3 : 5
    })
  };

  return chakraStyles;
};

function Select(props: any) {
  const placeholderColor = useColorModeValue("gray.700", "whiteAlpha.300");
  const { size, fontSize, isFullWidth } = props;

  return (
    <Box {...props.innerProps}>
      <ChakaUIReactSelect
        useBasicStyles
        chakraStyles={generateChakraStyles({
          size,
          fontSize,
          isFullWidth,
          placeholderColor
        })}
        {...props}
      />
    </Box>
  );
}

function AsyncSelect(props: any) {
  const placeholderColor = useColorModeValue("gray.700", "whiteAlpha.300");
  const { size, fontSize, isFullWidth } = props;

  return (
    <Box {...props.innerProps}>
      <ChakraUIReactAsyncSelect
        useBasicStyles
        chakraStyles={generateChakraStyles({
          size,
          fontSize,
          isFullWidth,
          placeholderColor
        })}
        {...props}
      />
    </Box>
  );
}

export { Select, AsyncSelect, chakraComponents };
export type { DropdownIndicatorProps };
